import React, { useState } from 'react';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithCredential, signInWithEmailAndPassword, createUserWithEmailAndPassword,fetchSignInMethodsForEmail } from 'firebase/auth';
import { doc, setDoc, getDoc, Timestamp } from "firebase/firestore";
import { auth, provider, db } from "../../firebase_service/firebase";
import '../../css/components/Login.css';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';



const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [rePassword, setRePassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
 
  const extId =process.env.REACT_APP_EXTENSION_ID;

 
  const handleGoogleLogin = async (name, email, idtoken, photourl) => {
     
    email=email.trim();
    name=name.trim();

    try {

     

      const redirectUrl = `chrome-extension://${extId}/callback.html` +
        `#photourl=${encodeURIComponent(photourl)}` +
        `&isGoogleLog=${encodeURIComponent("google")}` +
        `&email=${encodeURIComponent(email)}` +
        `&name=${encodeURIComponent(name)}` +
        `&start_tag=${encodeURIComponent('<a>')}` +
        `&end_tag=${encodeURIComponent('</a>')}` +
        `&idtoken=${encodeURIComponent(idtoken)}`;

      window.location.href = redirectUrl;

    } catch (error) {
      alert("Login failed.");
    }
  };

  const handleEmailPasswordLogin = async (currentemail,currentpassword) => {
    try {
      setIsLoading(true);
      
       currentemail=currentemail.trim();
       currentpassword=currentpassword.trim();
       
       if(!currentemail ||!currentpassword) {
        setIsLoading(false);
        alert('Email and password cannot be empty.');
        return;
      }
       try {
        const methods = await fetchSignInMethodsForEmail(auth, currentemail);
    
        if (methods.includes("google.com")) {
          setIsLoading(false);
           alert("This email is registered with Google Sign-In,login with Google Sign-In instead.");
            return;      
          } 
      } catch (error) {
        setIsLoading(false);
        alert("Login failed.");
       return;
      }

      
        try{
          await signInWithEmailAndPassword(auth, currentemail, currentpassword);
        }catch(error){
          setIsLoading(false);
          var errorMessage = "Invalid email or password";
         if(error.message.includes("invalid-credential")){
          setIsLoading(false);
           alert("Invalid email or password or your account already login through google.");
           return;
         }
         if (error.code === 'auth/user-not-found') {
          errorMessage = "User not found. Please check your email.";
        } else if (error.code === 'auth/wrong-password') {
          errorMessage = "Incorrect password. Please try again.";
        } else if (error.code === 'auth/invalid-email') {
          errorMessage = "Invalid email address.";
        }
        setIsLoading(false);
        alert(errorMessage);
        return;
        }
        setIsLoading(false);

        const redirectUrl = `chrome-extension://${extId}/callback.html` +
          `#photourl=${encodeURIComponent(null)}` +
          `&isGoogleLog=${encodeURIComponent("notgoogle")}` +
          `&email=${encodeURIComponent(currentemail)}` +
          `&password=${encodeURIComponent(currentpassword)}` +
          `&name=${encodeURIComponent(null)}` +
          `&start_tag=${encodeURIComponent('<a>')}` +
          `&end_tag=${encodeURIComponent('</a>')}` +
          `&idtoken=${encodeURIComponent(null)}`;

        window.location.href = redirectUrl;
      
    } catch (error) {
      setIsLoading(false);
     alert(`Login failed`);
    }
  };

  const handleEmailPasswordSignUp = async (email,password,rePassword) => {
    
    setIsLoading(true);
     // Trim the name and email valu
     let current_email=email.trim();
    let current_password=password.trim();
    let current_rePassword=rePassword.trim();
    
    const nameRegex = /^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{3,15}$/;
    if (!nameRegex.test(name)) {
      setIsLoading(false);
      alert('Name must be between 3 and 15 characters, and contain only text or special characters (no emojis).');
      return;
    }



    if(!current_email ||!current_password||!current_rePassword) {
      setIsLoading(false);
      alert('Email and password cannot be empty.');
      return;
    }

    if (current_password.length < 6) {
      setIsLoading(false);
      alert('Password should be at least 6 characters.');
      return;
    }

    

    if(current_password !== current_rePassword) {
      setIsLoading(false);
      alert('Passwords do not match.');
      return;
    }

    try {
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);
  
      
  
      if (signInMethods.includes("google.com")) {
        setIsLoading(false);
        alert("This email is registered with Google Sign-In,login with Google Sign-In instead.");
        return;
      }
  
      if (signInMethods.includes("password")) {
        setIsLoading(false);
       alert("This email is already registered with Email/Password.please login");
        return;
        }

      const result = await createUserWithEmailAndPassword(auth, email, password);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      const now = Timestamp.now();
      const jsDate = now.toDate(); // Convert Firestore Timestamp to JS Date

      // Extract year and month
      const year = jsDate.getFullYear();
      const month = jsDate.getMonth(); // 0 = Jan, 1 = Feb, ..., 11 = Dec

      // Create start date: 1st of current month at 00:00
      const start_date = Timestamp.fromDate(new Date(year, month, 1, 0, 0, 0));

      // Create end date: last day of current month at 23:59:59
      const lastDay = new Date(year, month + 1, 0).getDate(); // Get last day of current month
      const end_date = Timestamp.fromDate(new Date(year, month, lastDay, 23, 59, 59));

      if (!userSnap.exists()) {
      
        await setDoc(userRef, {
          uid: user.uid,
          username: name, // Use the 'name' state variable
          email: user.email,
          photoURL: null,
          createdAt: Timestamp.now(),
          lastLoginAt: Timestamp.now(),

          plan_details: {
            isFreeCreditDone: false,
            plan: "FREE",
            start_date: start_date,
            end_date: end_date,
            remaining_prompts: 20,
          },
        });
      } else {
        // User exists, update last login time
       
        await setDoc(userRef, {
          lastLoginAt: Timestamp.now(),
        }, { merge: true });
      }

      setIsLoading(false);
   

     

        const redirectUrl = `chrome-extension://${extId}/callback.html` +
          `#photourl=${encodeURIComponent(null)}` +
          `&isGoogleLog=${encodeURIComponent("notgoogle")}` +
          `&email=${encodeURIComponent(current_email)}` +
          `&password=${encodeURIComponent(current_password)}` +
          `&name=${encodeURIComponent(null)}` +
          `&start_tag=${encodeURIComponent('<a>')}` +
          `&end_tag=${encodeURIComponent('</a>')}` +
          `&idtoken=${encodeURIComponent(null)}`;

      window.location.href = redirectUrl;
     
      // Redirect or perform other actions upon successful signup
    } catch (error) {
      setIsLoading(false);
      const errormessage = error.message;
      if(errormessage.includes("email-already-in-use")){
        alert("Email already in use. Please use a different email.");
        return;
      }
      alert(`Signup failed`);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-title">{isSignUp ? 'Sign Up for Your Extension' : 'Login to Your Extension'}</div>

        <div className="login-form">
          {isSignUp && (
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="login-input"
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          />
          <div className="password-input-container">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value.trim())}
              className="login-input"
            />
            <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? (
                <i className="fa-solid fa-eye-slash"></i>
              ) : (
                <i className="fa-solid fa-eye"></i>
              )}
            </span>
          </div>
          {isSignUp && (
            <div className="password-input-container">
              <input
                type={showRePassword ? 'text' : 'password'}
                placeholder="Re-enter Password"
                value={rePassword}
                onChange={(e) => setRePassword(e.target.value.trim())}
                className="login-input"
              />
              <span className="password-toggle" onClick={() => setShowRePassword(!showRePassword)}>
                {showRePassword ? (
                  <i className="fa-solid fa-eye-slash"></i>
                ) : (
                  <i className="fa-solid fa-eye"></i>
                )}
              </span>
            </div>
          )}
            {isSignUp ? (
              <button onClick={()=>handleEmailPasswordSignUp(email,password,rePassword)} className="login-button">
                {isLoading ? 'Loading...' : 'Sign Up with Email'}
              </button>
            ) : (
              <button onClick={()=>handleEmailPasswordLogin(email,password)} className="login-button">
                {isLoading ? 'Loading...' : 'Sign In with Email'}
              </button>
          )}
        </div>

        <div className="login-toggle">
          {isSignUp ? (
            <p>Already have an account? <span onClick={() => setIsSignUp(false)}>Sign In</span></p>
          ) : (
            <p>Don't have an account? <span onClick={() => setIsSignUp(true)}>Sign Up</span></p>
          )}
        </div>

        <div className="login-separator">OR</div>

        <div className="login-btn">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {

              const credential = credentialResponse.credential;
             


              const { name, email, sub, picture } = jwtDecode(credentialResponse.credential);



              await handleGoogleLogin(name, email, credential, picture);



            }}
            onError={() =>alert("login failed")} />
        </div>


      </div>
    </div>
  );
};

export default Login;